import React from 'react';
import classNames from 'classnames';
import Icon from '~/app/common/Icon';
import classes from './style.module.scss';

export interface SubTitleProps {
    name?: string
    checked?: boolean
    className?: string | string[]
}

export type SubTitleComponent = React.FC<SubTitleProps>

const SubTitle: SubTitleComponent = ({name, checked, className}) => {
    return (
        <div className={classNames(
            classes['sub-title'], 
            (checked && classes['ok']), 
            className && (Array.isArray(className) ? className.map(cls => classes[cls]) : classes[className])
        )}>
            {name}
            {checked && <Icon name={'check'} className={classes['green-icon']} size={'14'}/>}
        </div>
    );
};

export default SubTitle
